/* eslint-disable max-lines-per-function, import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useRef, useEffect } from "react";
import ArtworkAlert from "../ArtworkAlert.vue";
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./Sizes.scss";
import { renderList } from "common/vue/render-list";

export default function Sizes({ ...restProps }) {
  const heights = [
    { label: "2 Inches", value: 2 },
    { label: "2.5 Inches", value: 2.5 },
    { label: "3 Inches", value: 3 }
  ];
  const heightValues = heights.map(height => height.value);

  const maxLengths = [
    { label: "9 Inches", value: 9 },
    { label: "11 Inches", value: 11 },
    { label: "14 Inches", value: 14 }
  ];
  const maxLengthValues = maxLengths.map(maxLength => maxLength.value);

  const timerRef = useRef(null);
  const [letterHeight, setLetterHeight] = useState(null);
  const [letterMaxLength, setLetterMaxLength] = useState(null);
  const letterHeightRef = useRef(letterHeight);
  letterHeightRef.current = letterHeight;
  const letterMaxLengthRef = useRef(letterMaxLength);
  letterMaxLengthRef.current = letterMaxLength;
  const prevHeightRef = useRef(null);
  const prevMaxLengthRef = useRef(null);

  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function isHeightSelected(option: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return letterNumberArtwork().height === option.value && !letterNumberArtwork().showCustomHeight;
  }

  function isMaxLengthSelected(option: any) {
    return (
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      letterNumberArtwork().maxLength === option.value && !letterNumberArtwork().showCustomMaxLength
    );
  }

  function showCustomHeight() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return letterNumberArtwork().showCustomHeight;
  }

  function showCustomMaxLength() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return letterNumberArtwork().showCustomMaxLength;
  }

  function dtfMinHeight() {
    // @ts-expect-error TS(4111): Property 'dtfMinHeight' comes from an index signat... Remove this comment to see the full error message
    return store.dtfMinHeight;
  }

  function dtfMaxHeight() {
    // @ts-expect-error TS(4111): Property 'dtfMaxHeight' comes from an index signat... Remove this comment to see the full error message
    return store.dtfMaxHeight;
  }

  function dtfMinWidth() {
    // @ts-expect-error TS(4111): Property 'dtfMinWidth' comes from an index signatu... Remove this comment to see the full error message
    return store.dtfMinWidth;
  }

  function dtfMaxWidth() {
    // @ts-expect-error TS(4111): Property 'dtfMaxWidth' comes from an index signatu... Remove this comment to see the full error message
    return store.dtfMaxWidth;
  }

  function isValidLetterHeight() {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    return letterHeightRef.current >= dtfMinHeight() && letterHeightRef.current <= dtfMaxHeight();
  }

  function isValidLetterMaxLength() {
    return (
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      letterMaxLengthRef.current! >= dtfMinWidth() && letterMaxLengthRef.current! <= dtfMaxWidth()
    );
  }

  function updateHeight(option: any) {
    let height = option.value;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (height > dtfMaxHeight()) height = dtfMaxHeight();
    const isValid =
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      height >= dtfMinHeight() && height <= dtfMaxHeight() && isValidLetterMaxLength();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid,
      height
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (isValid) store.updateAllLetterPreviews();
  }

  function updateMaxLength(option: any) {
    let maxLength = option.value;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (maxLength > dtfMaxWidth()) maxLength = dtfMaxWidth();
    const isValid =
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      isValidLetterHeight() && maxLength >= dtfMinWidth() && maxLength <= dtfMaxWidth();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid,
      maxLength
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (isValid) store.updateAllLetterPreviews();
  }

  function handleHeightSet(option: any) {
    setLetterHeight(option.value);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      showCustomHeight: false
    });
    updateHeight(option);
  }

  function handleMaxLengthSet(option: any) {
    setLetterMaxLength(option.value);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      showCustomMaxLength: false
    });
    updateMaxLength(option);
  }

  function handleCustomHeight() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid: false,
      showCustomHeight: true,
      height: null
    });
  }

  function handleCustomMaxLength() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid: false,
      showCustomMaxLength: true,
      maxLength: null
    });
  }

  function handleCustomInputChange(event: any, callback: any) {
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    clearTimeout(timerRef.current);
    const { value } = event.target;
    let inputValue = value.match(/(\d+(\.\d*)?)/);
    inputValue = inputValue ? inputValue[0] : "0";
    const splitHeight = inputValue.split(".");
    if (splitHeight[1] && splitHeight[1].length > 2) {
      inputValue = Number([splitHeight[0], splitHeight[1].slice(0, 2)].join("."));
    }
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
    timerRef.current = setTimeout(() => {
      callback({ value: Number(inputValue) });
    }, 1000);
  }

  useEffect(() => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const currentHeight = letterNumberArtwork().height;
    if (prevHeightRef.current && currentHeight === null) {
      setLetterHeight(null);
    }
    prevHeightRef.current = currentHeight;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  }, [store.letterNumberArtwork.height]);

  useEffect(() => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const currentMaxLength = letterNumberArtwork().maxLength;
    if (prevMaxLengthRef.current && currentMaxLength === null) {
      setLetterMaxLength(null);
    }
    prevMaxLengthRef.current = currentMaxLength;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  }, [store.letterNumberArtwork.maxLength]);

  useEffect(() => {
    // @ts-expect-error TS(2339): Property 'height' does not exist on type 'unknown'... Remove this comment to see the full error message
    const { height, maxLength } = letterNumberArtwork();
    if (!height || !maxLength) {
      return;
    }
    const h = Number(height);
    const ml = Number(maxLength);
    const minH = Number(dtfMinHeight());
    const maxH = Number(dtfMaxHeight());
    const minW = Number(dtfMinWidth());
    const maxW = Number(dtfMaxWidth());
    const isValid = h >= minH && h <= maxH && ml >= minW && ml <= maxW;
    let showCustomHeightInput = false;
    let showCustomMaxLengthInput = false;
    if (!heightValues.includes(height)) showCustomHeightInput = true;
    if (!maxLengthValues.includes(maxLength)) showCustomMaxLengthInput = true;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      isValid,
      showCustomHeight: showCustomHeightInput,
      showCustomMaxLength: showCustomMaxLengthInput
    });
  }, []);

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("sizes", restProps.className)}>
      <h3>Letter Height</h3>
      <div className="sizes__height">
        {renderList(heights, height => (
          <div
            className={cn({
              sizes__size: true,
              "sizes__size--selected": isHeightSelected(height)
            })}
            key={height.value}
            onClick={() => {
              handleHeightSet(height);
            }}
            data-testid="sizes-div"
          >
            {height.label}
          </div>
        ))}
        <div
          className={cn({
            sizes__size: true,
            "sizes__size--selected": showCustomHeight()
          })}
          onClick={() => {
            handleCustomHeight();
          }}
          data-testid="sizes-div-1"
        >
          {" "}
          Custom{" "}
        </div>
      </div>
      {showCustomHeight() ? (
        <>
          <p className="sizes__label">Height (inches)</p>
          <input
            className="sizes__input"
            value={letterHeight ?? ""}
            onInput={e => {
              // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to parameter of type 'SetStateAction<null>'.
              setLetterHeight(e.target.value);
              handleCustomInputChange(e, updateHeight);
            }}
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
            maxLength="6"
            type="number"
            data-testid="sizes-input"
          />
          {letterHeight && !isValidLetterHeight() ? (
            <ArtworkAlert className="sizes__error" data-testid="sizes-error">
              {"Please enter a valid height between "}
              {dtfMinHeight()}
              {" and "}
              {dtfMaxHeight()}
              {" inches"}
            </ArtworkAlert>
          ) : null}
        </>
      ) : null}
      <h3>Maximum Length</h3>
      <div className="sizes__max-lengths">
        {renderList(maxLengths, maxLength => (
          <div
            className={cn({
              sizes__size: true,
              "sizes__size--selected": isMaxLengthSelected(maxLength)
            })}
            key={maxLength.value}
            onClick={() => {
              handleMaxLengthSet(maxLength);
            }}
            data-testid="sizes-div-2"
          >
            {maxLength.label}
          </div>
        ))}
        <div
          className={cn({
            sizes__size: true,
            "sizes__size--selected": showCustomMaxLength()
          })}
          onClick={() => {
            handleCustomMaxLength();
          }}
          data-testid="sizes-div-3"
        >
          {" "}
          Custom{" "}
        </div>
      </div>
      {showCustomMaxLength() ? (
        <>
          <p className="sizes__label">Length (inches)</p>
          <input
            className="sizes__input"
            value={letterMaxLength ?? ""}
            onInput={e => {
              // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to parameter of type 'SetStateAction<null>'.
              setLetterMaxLength(e.target.value);
              handleCustomInputChange(e, updateMaxLength);
            }}
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
            maxLength="6"
            type="number"
            data-testid="sizes-input-1"
          />
          {letterMaxLength && !isValidLetterMaxLength() ? (
            <ArtworkAlert className="sizes__error" data-testid="sizes-error-1">
              {"Please enter a valid max length between "}
              {dtfMinWidth()}
              {" and "}
              {dtfMaxWidth()}
              {" inches"}
            </ArtworkAlert>
          ) : null}
        </>
      ) : null}
    </div>
  );
}
